import domready from 'domready'
import BackToTopController from './controllers/back-to-top-controller'

export default function initBackToTopController () {
  domready(() => {
    const element = document.querySelector('.floating-back-to-top')
    if (element) {
      // eslint-disable-next-line no-new
      new BackToTopController(element)
    }
  })
}
